<template>
    <div class="cz2__customizer">
        <menu-bar></menu-bar>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <review v-if="selectedStep === 'review' || returnTo === 'review'">
            </review>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <colors v-if="selectedStep === 'colors'">
            </colors>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <design-side v-if="selectedStep === 'side'">
            </design-side>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <images v-if="selectedStep === 'images'">
            </images>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <texts v-if="selectedStep === 'text'">
            </texts>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <monograms v-if="selectedStep === 'monogram'">
            </monograms>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <product-details v-if="selectedStep === 'info'">
            </product-details>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <product-help v-if="selectedStep === 'help' || selectedStep === 'help-child'">
            </product-help>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <product-help-child v-if="selectedStep === 'help-child'">
            </product-help-child>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <group-ordering v-if="selectedStep === 'group'">
            </group-ordering>
        </transition>

        <renderer></renderer>

        <header-bar></header-bar>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__customizer {
            position: relative;

            left: 0;
            top: 0;
            width: 100%;
            // IE11
            min-height: 100%;
            min-height: var(--app-height);
            height: var(--app-height);
            max-height: var(--app-height);

            display: flex;
            flex-direction: column-reverse;

            @include respond-above(sm) {
                display: block;
                position: absolute;
            }
        }

        .cz2__panel.cz2__panel--secondary {
            &.cz2__fade-secondary-enter-active, &.cz2__fade-secondary-leave-active {
                transition: transform $transition-fast ease-out;
            }

            &.cz2__fade-secondary-enter, &.cz2__fade-secondary-leave-to {
                &.cz2__panel--secondary-fullscreen {
                    transform: translate3d(100vw, 0, 0);

                    @include respond-above(sm) {
                        transform: translate3d($sidebar-width-large, 0, 0);
                    }
                }

                &:not(.cz2__panel--secondary-fullscreen) {
                    transform: translate3d(100vw, 0, 0);

                    @include respond-above(sm) {
                        transform: translate3d($sidebar-width-large, 0, 0);
                    }
                }
            }
        }
    }
</style>

<script>
    import HeaderBar from './HeaderBar.vue';
    import MenuBar from './Menu.vue';
    import Renderer from './Renderer.vue';
    import Colors from './Colors.vue';
    import DesignSide from './DesignSide.vue';
    import Images from './Images.vue';
    import Texts from './Text.vue';
    import Monograms from './Monogram.vue';
    import ProductDetails from './ProductDetails.vue';
    import ProductHelp from './ProductHelp.vue';
    import ProductHelpChild from './ProductHelpChild.vue';
    import GroupOrdering from './GroupOrdering.vue';
    import Review from './Review.vue';

    export default {
        components: {
            HeaderBar,
            MenuBar,
            Renderer,
            Colors,
            Images,
            Texts,
            Monograms,
            DesignSide,
            ProductDetails,
            ProductHelp,
            ProductHelpChild,
            GroupOrdering,
            Review,
        },
        data() {
            return {};
        },
        computed: {
            selectedStep() {
                return this.$store.state.selectedStep;
            },

            returnTo() {
                return this.$store.state.selectedStepParameters && this.$store.state.selectedStepParameters.returnTo;
            },
        },
        methods: {
            afterEnterTransition() {
                this.$store.dispatch('globalEvent', {
                    event: 'secondaryEntered',
                });
            },
        },
    };
</script>
